
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/faq",
      function () {
        return require("private-next-pages/investor/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/faq"])
      });
    }
  